import React from 'react'
import NavbarLayout from './NavbarLayout'
import SidebarLayout from './SidebarLayout'
import { Outlet } from 'react-router-dom'

type Props = {}

const DashboardLayout = (props: Props) => {
  return (
    <div className='w-full overflow-hidden'>
      <NavbarLayout />
      <div className="flex h-[95vh]">
        <SidebarLayout />
        <div className="font-sans flex-grow overflow-y-auto p-4">
          <Outlet />
        </div>
      </div>
    </div>
  )
}

export default DashboardLayout
